import request from '@/utils/request'

// 查询提现查单列表
export function listWithdrawCheckOrders(params) {
  return request({
    url: '/checkOrder/listWithdrawCheckOrders',
    method: 'get',
    params,
  })
}

// 查询支付查单列表
export function listPayCheckOrders(params) {
  return request({
    url: '/checkOrder/listPayCheckOrders',
    method: 'get',
    params,
  })
}

// 更新查单
export function updateCheckOrder(id, data) {
  return request({
    url: `/checkOrder/updateCheckOrder/${id}`,
    method: 'patch',
    data,
  })
}

// 查单
export function addCheckOrder(data) {
  return request({
    url: '/checkOrder/addCheckOrder',
    method: 'post',
    data,
  })
}

// 恢复催单
export function recoverUrgingOrder(id) {
  return request({
    url: `/checkOrder/recoverUrgingOrder/${id}`,
    method: 'post',
  })
}

// 挂起催单
export function suspendUrgingOrder(id) {
  return request({
    url: `/checkOrder/suspendUrgingOrder/${id}`,
    method: 'post',
  })
}


// WEBPACK FOOTER //
// ./src/api/checkOrder.js